import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import hospitalSlice from './slices/hospitalSlice';
import deviceSlice from './slices/deviceSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    hospitals: hospitalSlice,
    devices: deviceSlice,
  },
});